import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import './i18n'; // Initialize i18n

// Layout Components
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';

// Public Pages
import HomePage from './pages/public/HomePage';
import AboutPage from './pages/public/AboutPage';
import GalleryPage from './pages/public/GalleryPage';
import ContactPage from './pages/public/ContactPage';
import PrivacyPolicyPage from './pages/public/PrivacyPolicyPage';
import TermsPage from './pages/public/TermsPage';

// Admin Pages
import LoginPage from './pages/admin/LoginPage';
import AdminDashboard from './pages/admin/AdminDashboard';
import GalleryManager from './pages/admin/GalleryManager';
import CategoriesManager from './pages/admin/CategoriesManager';
import ContactSubmissions from './pages/admin/ContactSubmissions';
import AboutManager from './pages/admin/AboutManager';
import PrivacyPolicyManager from './pages/admin/PrivacyPolicyManager';
import TermsManager from './pages/admin/TermsManager';
import SettingsPage from './pages/admin/SettingsPage';
import MigrationPage from './pages/admin/MigrationPage';

// Protected Route
import ProtectedRoute from './components/admin/auth/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <Router>
        <LanguageProvider>
          <div className="App">
            <Toaster position="top-right" />

          <Routes>
            {/* Public Routes */}
            <Route path="/" element={
              <>
                <Header />
                <HomePage />
                <Footer />
              </>
            } />
            <Route path="/about" element={
              <>
                <Header />
                <AboutPage />
                <Footer />
              </>
            } />
            <Route path="/gallery" element={
              <>
                <Header />
                <GalleryPage />
                <Footer />
              </>
            } />
            <Route path="/contact" element={
              <>
                <Header />
                <ContactPage />
                <Footer />
              </>
            } />
            <Route path="/privacy-policy" element={
              <>
                <Header />
                <PrivacyPolicyPage />
                <Footer />
              </>
            } />
            <Route path="/terms" element={
              <>
                <Header />
                <TermsPage />
                <Footer />
              </>
            } />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<LoginPage />} />

            <Route path="/admin/dashboard" element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } />

            <Route path="/admin/gallery" element={
              <ProtectedRoute>
                <GalleryManager />
              </ProtectedRoute>
            } />

            <Route path="/admin/categories" element={
              <ProtectedRoute>
                <CategoriesManager />
              </ProtectedRoute>
            } />

            <Route path="/admin/contacts" element={
              <ProtectedRoute>
                <ContactSubmissions />
              </ProtectedRoute>
            } />

            <Route path="/admin/about" element={
              <ProtectedRoute>
                <AboutManager />
              </ProtectedRoute>
            } />

            <Route path="/admin/privacy" element={
              <ProtectedRoute>
                <PrivacyPolicyManager />
              </ProtectedRoute>
            } />

            <Route path="/admin/terms" element={
              <ProtectedRoute>
                <TermsManager />
              </ProtectedRoute>
            } />

            <Route path="/admin/settings" element={
              <ProtectedRoute>
                <SettingsPage />
              </ProtectedRoute>
            } />

            <Route path="/admin/migration" element={
              <ProtectedRoute>
                <MigrationPage />
              </ProtectedRoute>
            } />

            {/* Catch all - redirect to home */}
            <Route path="*" element={
              <>
                <Header />
                <div className="min-h-screen flex items-center justify-center">
                  <div className="text-center">
                    <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
                    <p className="text-xl text-gray-600 mb-8">Page not found</p>
                    <a href="/" className="text-primary-600 hover:text-primary-700 font-medium">
                      Go back home
                    </a>
                  </div>
                </div>
                <Footer />
              </>
            } />
          </Routes>
          </div>
        </LanguageProvider>
      </Router>
    </AuthProvider>
  );
}

export default App;
